import {SWF_FORM_PREFIX} from './constants';

export const filterFields = fields => Object.keys(fields).
filter(key => !(key.startsWith('_') || key.startsWith('swf:') || key.startsWith('jsonata:'))).
reduce((obj, key) => {
  obj[key.replace(SWF_FORM_PREFIX, '')] = fields[key];
  return obj;
}, {});